import { H2RInput } from "../../imports";
import { H2RSelect } from "../../imports";
import { imageTypesDefinitions } from "../../imports";
import { ImagePreview } from "../FormElements";
import { replaceWithDataSource } from "../helpers/variable";
import { availableIcons } from "../Icons";
import { useSelector } from "react-redux";

export const GraphicEditor = ({ cue, media, onUpdate }) => {
	const cloud = useSelector((state) => state.rundown.cloud) || false;
	return (
		<>
			<H2RSelect
				label="Icon"
				selected={cue.icon}
				onChange={(choice) => {
					onUpdate({ icon: choice });
				}}
				options={[
					...availableIcons.map((icon) => {
						return icon;
					}),
					{
						label: "- - - -",
						value: "",
					},
					{
						label: "Custom text",
						value: "custom-text",
					},
					{
						label: "Custom image",
						value: "custom-image",
					},
				]}
			/>
			{cue.icon === "custom-text" && (
				<H2RInput
					label="Custom text (Large text)"
					value={cue.customIcon}
					onChange={(value) => {
						onUpdate({
							customIcon: value,
						});
					}}
				/>
			)}
			{cue.icon === "custom-image" && (
				<>
					{cloud ? (
						<H2RInput
							label="Image URL"
							value={cue.url}
							placeholder={`https://media.h2r.graphics/image.png`}
							onChange={(change) => {
								onUpdate({ url: change });
							}}
						/>
					) : (
						<H2RSelect
							selected={cue.customImage}
							label="Image"
							options={
								media.length === 0
									? [
											{
												label: "Add images in the Media tab",
												value: ``,
												disabled: true,
											},
									  ]
									: [
											...media
												.filter((item) =>
													imageTypesDefinitions.includes(item.mimetype)
												)
												.filter((item) => !item.partOf)
												.map((item) => {
													return {
														label: item.originalname,
														value: item.filename,
													};
												}),
									  ]
							}
							onChange={(value) => {
								return onUpdate({ customImage: value });
							}}
						/>
					)}
					<ImagePreview image={cloud ? cue.url : cue.customImage} />
				</>
			)}
			<H2RInput
				label="Message text (Large text)"
				value={cue.body}
				onChange={(value) => {
					onUpdate({
						body: value,
					});
				}}
			/>
		</>
	);
};

export const GraphicCueContent = ({ cue, dynamicText, dynamicLists }) => {
	return (
		<div className="overflow-ellipsis w-48 md:w-auto max-w-xs md:max-w-sm lg:max-w-lg  whitespace-nowrap overflow-hidden">
			<span className="font-semibold">
				{cue.icon === "custom-text" && (
					<span className="mr-2">{cue.customIcon}</span>
				)}
				{replaceWithDataSource(cue.body, dynamicText, dynamicLists, true) ||
					"Message"}
			</span>
		</div>
	);
};
